import { useNavigate } from "react-router-dom";
import { GetAllEventsResponse } from "../../redux/features/admin/event/events.types";
import { currencyShorts, eventStatusPillMap } from "../../utils/constants";
import { formatDate, formatToCurrency } from "../../utils/helpers";
import { QueryParams } from "../../utils/types";
import { Pill } from "../pill";
import { TableComponent } from "../table";

export const EventTable = ({
  eventsData,
  query,
  fetchingEvents,
  setQuery,
}: {
  eventsData?: GetAllEventsResponse;
  query: QueryParams;
  fetchingEvents: boolean;
  setQuery: (query: QueryParams) => void;
}) => {
  const navigate = useNavigate();
  return (
    <div className="w-full">
      <TableComponent
        headers={[]}
        rows={
          eventsData?.data?.events?.map((event, idx) => {
            return {
              id: idx,
              items: [
                <div
                  className={`flex w-full flex-1 flex-col gap-2 md:flex-row md:items-center`}
                >
                  <img
                    src={event.image}
                    alt="event banner"
                    className="block h-[40px] w-[40px] overflow-hidden rounded-sm object-cover"
                  />

                  <p className="flex flex-1 flex-wrap items-center gap-[2px] text-sm text-grey-600">
                    <span className="font-bold text-grey-900">
                      {event.name}
                    </span>
                    <span>
                      {event?.minimumTicketAmount > 0
                        ? `∙ From ${formatToCurrency(
                            event.minimumTicketAmount,
                            {
                              currency: currencyShorts[event?.currency],
                            },
                          )}`
                        : "∙ FREE"}
                    </span>
                    <span>{event?.currency === "NGN" ? " 🇳🇬" : " 🇨🇦 "}</span>
                    <span>{event.isTrending && " 🔥"}</span>
                  </p>
                  <div className="flex flex-row flex-wrap items-center gap-2">
                    <Pill
                      className=""
                      text={eventStatusPillMap[event?.status!]?.text}
                      variation={
                        event.status === "completed"
                          ? "grey"
                          : eventStatusPillMap[event?.status!]?.variant
                      }
                    />
                    <Pill
                      text={`${event.totalTicketsSold || "NO"} TICKET${event.totalTicketsSold > 1 ? "S" : ""} SOLD`}
                      variation={"grey"}
                    />
                    <p className="text-sm text-grey-600">
                      On {formatDate(event.startDate, "MMMM DD, YYYY")} ∙{" "}
                      {event.startTime}
                    </p>
                  </div>
                </div>,
              ],
            };
          }) ?? []
        }
        loadingRows={query.limit}
        isLoading={fetchingEvents}
        isTableEmpty={[0, undefined].includes(eventsData?.data?.events?.length)}
        emptyTitle="No Events"
        emptySubTitle=""
        isRowClickable
        onRowClick={(idx) => {
          navigate(`/events/${eventsData?.data?.events[idx]?._id}`);
        }}
        emptyImage="/assets/images/calendar-3d.png"
        currentPage={query.page ?? 1}
        totalCount={eventsData?.data?.stats?.total ?? 0}
        itemsPerPage={query.limit!}
        pageRangeDisplayed={3}
        onPageChange={(page) => {
          setQuery({
            ...query,
            page: page,
          });
        }}
        className="mt-3"
      />
    </div>
  );
};
